import React, { useState, useEffect, MouseEventHandler } from 'react';
import { isEmpty } from 'lodash';
import { MenuItem, Select } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Container,
  RefreshButton,
  SearchButton,
  StyledInputBase,
} from 'components/NewSearchBar/style';
import messages from 'containers/ExpertHomePage/messages';
import { translate } from 'containers/services/translate';
import { COLORS } from 'constants/design';
import { SEARCH_TYPE_IDS } from 'containers/ExpertHomePage/constants';

export interface SearchQuery {
  victimCIN: string | null;
  claimNumber: string | null;
  missionReference: string | null;
}
export interface SearchBarExpertProps {
  intl: IntlShape;
  searchQuery: any;
  setSearchQuery: Function;
  handlerSearch: Function;
  handlerRefresh: MouseEventHandler;
}

const SearchBarExpert: React.FC<SearchBarExpertProps> = (
  props,
): JSX.Element => {
  const { handlerSearch, handlerRefresh, searchQuery, setSearchQuery } = props;
  const [searchType, setSearchType] = useState([] as any);

  const [selectedSearchType, setSelectedSearchType] = useState(
    SEARCH_TYPE_IDS.CLAIM,
  );
  /* istanbul ignore next */
  const handleChangeSelectedSearchType = (
    e: React.ChangeEvent<{ value: unknown }>,
  ) => {
    setSelectedSearchType(e.target.value as string);
  };

  const [searchValue, setSearchValue] = useState<string | null>(null);
  /* istanbul ignore next */
  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value.trim());
  };
  const [searchValuePlaceHolder, setSearchValuePlaceHolder] = useState('');

  useEffect(() => {
    setSearchType(allSearchTypes['DEFAULT']);
  }, []);

  const allSearchTypes = {
    DEFAULT: [
      {
        id: SEARCH_TYPE_IDS.CLAIM,
        title: translate(messages.claimNumber, props),
      },
      {
        id: SEARCH_TYPE_IDS.VICTIM_CIN,
        title: translate(messages.victimCIN, props),
      },
      {
        id: SEARCH_TYPE_IDS.MISSION_REFERENCE,
        title: translate(messages.missionReference, props),
      },
    ],
  };

  useEffect(() => {
    const result = searchType.find(
      (type: { id: string }) => type.id === selectedSearchType,
    );
    if (result) setSearchValuePlaceHolder(`Saisir ${result.title}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSearchType, !isEmpty(searchType)]);

  /* istanbul ignore next */
  const assignValuesToSearchQueryBeforeSearch = () => {
    searchQuery.claimNumber = null;
    searchQuery.cin = null;
    searchQuery.reference = null;

    switch (selectedSearchType) {
      case SEARCH_TYPE_IDS.CLAIM:
        searchQuery.claimNumber = searchValue;
        break;
      case SEARCH_TYPE_IDS.VICTIM_CIN:
        searchQuery.cin = searchValue;
        break;
      case SEARCH_TYPE_IDS.MISSION_REFERENCE:
        searchQuery.reference = searchValue;
        break;
    }
    setSearchQuery(searchQuery);
    handlerSearch();
  };
  return (
    <Container>
      <Select
        value={selectedSearchType}
        onChange={handleChangeSelectedSearchType}
        input={
          <StyledInputBase borderRadiusLeft fullWidth textColor="black" bold />
        }
        data-testid="search-type"
      >
        {searchType.map((searchType: any) => (
          <MenuItem value={searchType.id}>{searchType.title}</MenuItem>
        ))}
      </Select>
      <StyledInputBase
        marginRight
        borderRadiusRight
        fullWidth
        textColor="black"
        bgColor={COLORS.FORM_INPUT_BG_GRAY}
        className="inputBase"
        placeholder={searchValuePlaceHolder}
        name="queryNumber"
        value={searchValue}
        onChange={handleChangeSearchValue}
        inputProps={{
          'aria-label': 'searchedValue',
          className: 'inputTextStyle',
        }}
      />
      <SearchButton
        data-testid="search-button"
        onClick={assignValuesToSearchQueryBeforeSearch}
      >
        <SearchIcon />
      </SearchButton>
      <RefreshButton data-testid="refresh-button" onClick={handlerRefresh}>
        <RefreshIcon />
      </RefreshButton>
    </Container>
  );
};

export default injectIntl(SearchBarExpert);
